import { getAuthHeaders, triggerUnauthorized } from "../auth/token";

const BASE = "/tracking";

async function checkAuth(res: Response): Promise<void> {
  if (res.status === 401) {
    triggerUnauthorized();
    throw new Error("Session expired or invalid. Please sign in again.");
  }
}

export type TrackedBacktestMeta = {
  id: string;
  name: string;
  groupLabel?: string;
  updatedAt: string;
};

export async function getTrackingList(): Promise<TrackedBacktestMeta[]> {
  const res = await fetch(BASE, { headers: getAuthHeaders() });
  await checkAuth(res);
  if (!res.ok) {
    const text = await res.text();
    let msg: string;
    try {
      const body = JSON.parse(text) as { detail?: string };
      msg = body.detail ?? text;
    } catch {
      msg = text || `Failed (${res.status})`;
    }
    throw new Error(msg);
  }
  const data = (await res.json()) as { backtests: TrackedBacktestMeta[] };
  return data.backtests ?? [];
}

export async function putTrackingList(backtestIds: string[]): Promise<TrackedBacktestMeta[]> {
  const res = await fetch(BASE, {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...getAuthHeaders() },
    body: JSON.stringify({ backtest_ids: backtestIds }),
  });
  await checkAuth(res);
  if (!res.ok) {
    const text = await res.text();
    let msg: string;
    try {
      const body = JSON.parse(text) as { detail?: string };
      msg = body.detail ?? text;
    } catch {
      msg = text || `Failed (${res.status})`;
    }
    throw new Error(msg);
  }
  const data = (await res.json()) as { backtests: TrackedBacktestMeta[] };
  return data.backtests ?? [];
}

export async function startMonitoring(): Promise<{ ok: boolean; warnings: string[] }> {
  const res = await fetch(`${BASE}/start`, { method: "POST", headers: getAuthHeaders() });
  await checkAuth(res);
  if (!res.ok) {
    const text = await res.text();
    let msg: string;
    try {
      const body = JSON.parse(text) as { detail?: string };
      msg = body.detail ?? text;
    } catch {
      msg = text || `Failed (${res.status})`;
    }
    throw new Error(msg);
  }
  return (await res.json()) as { ok: boolean; warnings: string[] };
}

export async function stopMonitoring(): Promise<{ ok: boolean }> {
  const res = await fetch(`${BASE}/stop`, { method: "POST", headers: getAuthHeaders() });
  await checkAuth(res);
  if (!res.ok) {
    const text = await res.text();
    let msg: string;
    try {
      const body = JSON.parse(text) as { detail?: string };
      msg = body.detail ?? text;
    } catch {
      msg = text || `Failed (${res.status})`;
    }
    throw new Error(msg);
  }
  return (await res.json()) as { ok: boolean };
}
